import React from "react";
import { Row } from "react-bootstrap";
import {
  PlayFill,
  PauseFill,
  ArrowCounterclockwise,
  SkipForward,
  SkipBackward,
  Bell,
  BellSlash,
} from "react-bootstrap-icons";
import "../style/player.scss";

const Player = (props) => {
  return (
    <div className="player-wrapper">
      <Row className="player">
        <ArrowCounterclockwise
          className="small-icon"
          color="#c1272d"
          size={96}
          onClick={props.reset}
        />
        <SkipBackward
          className="small-icon"
          color="#c1272d"
          size={96}
          onClick={props.back}
        />
        {props.isPlaying ? (
          <PauseFill color="#c1272d" size={240} onClick={props.pause} />
        ) : (
          <PlayFill color="#c1272d" size={240} onClick={props.start} />
        )}
        <SkipForward
          className="small-icon"
          color="#c1272d"
          size={96}
          onClick={props.forward}
        />
        {props.isMuted ? (
          <BellSlash
            className="small-icon"
            color="#c1272d"
            size={96}
            onClick={props.mute}
          />
        ) : (
          <Bell
            className="small-icon"
            color="#c1272d"
            size={96}
            onClick={props.mute}
          />
        )}
      </Row>
    </div>
  );
};

export default Player;
